import { gql } from "@apollo/client";

export const CREATE_OR_UPDATE_AUTO_RENEWAL_PREFERENCE = gql`
  mutation createOrUpdateAutoRenewalPreference($preferenceInput: AutoRenewalPreferenceInput!) {
    createOrUpdateAutoRenewalPreference(preferenceInput: $preferenceInput) {
      success
      messages
    }
  }
`;

export const CANCEL_AUTO_RENEWAL_PREFERENCE = gql`
  mutation cancelAutoRenewalPreference($currentSubscriptionId: String!) {
    cancelAutoRenewalPreference(currentSubscriptionId: $currentSubscriptionId) {
      success
      messages
    }
  }
`;

